import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";
import RichText from "./RichText";

export default function Ribbon() {
  const { t } = useLang();
  const items = t("ribbon");
  return (
    <div className="border-y border-gold/15 bg-surface/60 py-5 overflow-hidden" data-testid="editorial-ribbon">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-xl md:text-2xl text-champagne/70 px-8 whitespace-nowrap"><RichText text={item} path={`ribbon.${i}`} /></span>
            <span className="text-gold/50 text-xs">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
